"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("../../../List/List"));
var ListCard = function ListCard(_ref) {
  var heading = _ref.heading,
    items = _ref.items,
    listTemplate = _ref.listTemplate;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card--list d8-u-relative flex flex-column justify-between height-100%"
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    heading: heading,
    items: items,
    template: listTemplate
  }));
};
ListCard.propTypes = {
  heading: _propTypes["default"].string,
  listTemplate: _propTypes["default"].string,
  items: _propTypes["default"].array
};
var _default = exports["default"] = ListCard;